import React, { Component } from "react";

import UserPanel from "./Components/UserPanel";

import "../../assets/css/main.css";
import "../../assets/css/admin-styles.css";

import CoreService from "../../services/CoreService";
import ConfigService from "../../services/ConfigService";
import AuthResourceService from "../../services/AuthResourceService";
import {Box} from "@chakra-ui/react";


export default class UserManagementPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showNewSubModal: false,
            forcePanelRefresh: false,
            roles: []//,
            //schemas: [],
            //locations: []
        }

        this.coreService = new CoreService();
        this.configService = new ConfigService();
        this.authResourceService = new AuthResourceService();
    }

    async componentDidMount()
     {
        /*
        var locationsResult = await this.coreService.fetchLocations(this.props.userSession.gcid, this.props.userSession.token);
        if ((locationsResult).hasError) {
            locationsResult.messages.unshift("Problem loading Locations List.");
            this.props.onErrorPageRequest((locationsResult).messages);
            return;
        }
        var schemaMetadataResult = await this.coreService.fetchSchemaListByGcid(this.props.userSession.gcid, this.props.userSession.token);
        if ((schemaMetadataResult).hasError) {
            locationsResult.messages.unshift("Problem loading Schemas List.");
            this.props.onErrorPageRequest(schemaMetadataResult.messages);
            return;
        }
        if (schemaMetadataResult.dataResult.length < 1) {
            this.props.onErrorPageRequest("Your organization does not have any schemas assigned to it!");
            return;
        }
        */
       /*
        var rolesResult = await this.authResourceService.getAppRoles(this.props.userSession.token);
        if ((rolesResult).hasError) 
        {
            rolesResult.messages.unshift("Problem fetching available roles list.");
            this.props.onErrorPageRequest(rolesResult.messages);
            return;
        }
        */
       var roles = this.configService.getUserRoles();
        //var locations = locationsResult.dataResult.data.map((l) => { return { id: l.id, name: l.name } });
       // var schemas = schemaMetadataResult.dataResult.map((s) => { return { id: s.schemaId, name: s.schemaId } });
        //var roles = rolesResult.dataResult.map((r) => { return { id: r.id, name: r.displayName } });

        this.setState({ roles: roles}); //locations: locations, schemas: schemas, roles: roles });
    }


    render() {
        return (
            <div className="main">
                <Box bgColor='#0a597e' borderRadius='5px' width='100%' >
                    <UserPanel
                        isConnected={this.props.isConnected}
                        userSession={this.props.userSession}
                        onErrorPageRequest={this.props.onErrorPageRequest}
                        onLogoutRequest={this.props.onLogoutRequest}
                        panelRefreshRequest={this.state.forcePanelRefresh}
                        onPanelRefreshComplete={this.onPanelRefreshComplete}
                        roles={this.state.roles}
                        //locations={this.state.locations}
                        //schemas={this.state.schemas}

                    />
                </Box>

            </div>
        )

    }
}